import $ from 'jquery';
import Globals from '../helpers/Globals';

const { $body } = Globals;

const Header = {
    init() {
        $body.on('mouseenter', '.menu-item-has-children > a', e => this.toggleSubMenu(e));
        $body.on('click', '.js-toggle-submenu', e => this.toggleSubMenu(e));
        $body.on('click', '.js-close-sub-menu', e => this.closeSubMenu(e));
    },

    toggleSubMenu(e) {
        e.preventDefault();
        const $curr = $(e.currentTarget);

        if ($curr.parent().hasClass('sub-menu-open')) {
            $curr.parent().removeClass('sub-menu-open');
            $curr.parent().find('.js-close-sub-menu').remove();
        } else {
            $('.menu-item-has-children').removeClass('sub-menu-open');
            $curr.parent().children('.sub-menu').append('<li class="sub-menu-close js-close-sub-menu"></li>');
            $curr.parent().addClass('sub-menu-open');
        }
    },

    closeSubMenu(e) {
        e.stopPropagation();
        const $curr = $(e.currentTarget);

        $curr.parents('.menu-item-has-children').removeClass('sub-menu-open');
        $curr.remove();
    },
};

export default Header;
